
import { useEffect, useState, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
import { initPage } from '../App';

const Constelacao = () => {

    const [isDestacado, setIsDestacado] = useState(false)
    const [x, setX] = useState(50)
    const [y, setY] = useState(50)
    const [isMouseDown, setIsMouseDown] = useState(undefined)
    const dragOffset = useRef({ x: 0, y: 0 })

  useEffect(() => {
    initPage();
  }, [])

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsMouseDown(Date.now());
    
    const rect = e.target.getBoundingClientRect();
    dragOffset.current = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
    };
  }

  useEffect(() => {
    const handleMouseMove = (e) => {
        if (isMouseDown) {
            setX(e.pageX - dragOffset.current.x)
            setY(e.pageY - dragOffset.current.y)
        }
    }

    const handleMouseUp = () => {

        if(typeof isMouseDown === 'number' &&  Date.now() - isMouseDown < 1000){
            setIsDestacado(true)
        }

        setIsMouseDown(false)
    }

    if (isMouseDown) {
        window.addEventListener('mousemove', handleMouseMove)
        window.addEventListener('mouseup', handleMouseUp)
    }

    return () => {
        window.removeEventListener('mousemove', handleMouseMove)
        window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isMouseDown])

  return (
    <div className="page-container">
        <img src='/caca_palavras.png' width='500px' alt="Caça Palavras">
        </img>
        <img id="image" width='500px' src={isDestacado ? 'caca_palavras_destacado.png' : 'caca_palavras_destacar.png'}
            style={{
                'position': 'absolute',
                'background' : 'transparent',
                'left': `${x}px`,
                'top': `${y}px`,
                'cursor': 'pointer'
            }}
            onMouseDown={handleMouseDown}
            alt="Imagem destacável"
         >
            
        </img>
    </div>
  )
}

export default Constelacao;
